import { useContext } from 'react';
import Modal from '@/common/Modal';
import { formatAsSoonAsDate } from '@/vdp/LiteTextBoxes/utils';
import ModalContext from '~/context/vdp/ModalContext';
import type { RecommendedVehicle } from '~/contracts/common';
import type { EarliestDate } from '~/contracts/vdp';
import { Text, VehicleGrid, Wrapper } from './SimilarVehiclesModal.styles';
import DeliveryCard from '../DeliveryCard';

type OwnProps = {
  earliestDate: EarliestDate;
  vehicles: RecommendedVehicle[];
};

const SimilarVehiclesModal = ({ earliestDate, vehicles }: OwnProps) => {
  const { isSimilarVehiclesModalOpen, setSimilarVehiclesModal } =
    useContext(ModalContext);
  const vehicleCount = vehicles.length;
  const formattedEarliestDate = formatAsSoonAsDate(
    earliestDate.earliestDate,
    earliestDate.timeZone
  );

  return (
    <Modal
      open={isSimilarVehiclesModalOpen}
      headerText="SIMILAR VEHICLES"
      onToggle={() => setSimilarVehiclesModal(false)}
    >
      <Wrapper>
        <Text className={formattedEarliestDate ? 'inline-block' : 'hidden'}>
          These {vehicleCount} similar vehicles arrive sooner than{' '}
          <span className="block font-bold m:inline">
            {formattedEarliestDate}
          </span>
        </Text>
        <VehicleGrid>
          {vehicles.map(vehicle => (
            <DeliveryCard vehicle={vehicle} key={vehicle.vehicleId} />
          ))}
        </VehicleGrid>
      </Wrapper>
    </Modal>
  );
};

export default SimilarVehiclesModal;
